import { L10n, loadCldr, setCulture } from '@syncfusion/ej2-base';
import InovxLoader from './InovxLoader';

let loadedLocale: string | null = null;
let loadingPromise: Promise<void> | null = null;

async function getJson(url: string): Promise<any> {
    const response = await fetch(url);
    if (!response.ok) {
        throw new Error(`Unable to load Syncfusion locale data from ${url}.`);
    }

    return response.json();
}

export async function ensureSyncfusionLocaleLoaded(): Promise<void> {
    const syncfusionLocale = InovxLoader.getSyncfusionJS2Locale ? InovxLoader.getSyncfusionJS2Locale() : '';
    (window as any).SYNCFUSION_LOCALE = syncfusionLocale || null;

    if (!syncfusionLocale) {
        return;
    }

    setCulture(syncfusionLocale);

    if (loadedLocale === syncfusionLocale) {
        return;
    }

    if (loadingPromise) {
        return loadingPromise;
    }

    loadingPromise = (async () => {
        const cldrJsonUrls = InovxLoader.getCldrJsonUrls ? InovxLoader.getCldrJsonUrls() : null;
        if (cldrJsonUrls) {
            const cldrData = await Promise.all(cldrJsonUrls.map(getJson));
            cldrData.forEach((data) => loadCldr(data));
        }

        const jsonUrl = InovxLoader.getSyncfusionJS2JsonUrl ? InovxLoader.getSyncfusionJS2JsonUrl() : null;
        if (jsonUrl) {
            const localeData = await getJson(jsonUrl);
            L10n.load(localeData);

            const syncfusionCulture = InovxLoader.getSyncfusionLocale ? InovxLoader.getSyncfusionLocale() : '';
            if (syncfusionCulture && syncfusionCulture !== syncfusionLocale && localeData[syncfusionLocale]) {
                L10n.load({
                    [syncfusionCulture]: localeData[syncfusionLocale],
                });
            }
        }

        loadedLocale = syncfusionLocale;
    })().catch((error) => {
        console.warn('Failed to load Syncfusion locale data:', error);
    }).finally(() => {
        loadingPromise = null;
    });

    return loadingPromise;
}